import type { FieldError } from "react-hook-form";

import { isErrorFieldWithMessage } from "src/utils";

// TODO: where to put these?
export const getErrorMessage = (error: string | FieldError | undefined) => {
    return isErrorFieldWithMessage(error) ? error?.message : error;
};
